import {Component, OnInit, inject} from '@angular/core';
import {InputTagType, ValueType} from "../../../components/input/form-input/form-input.enums";
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import {Router} from "@angular/router";
import {MessageSeverity} from "../../../components/message-design-b/message.model";
import {AuthserviceService} from "../login-page/authservice.service";
import {CompoApp} from "../../../../services/CompoApp";
import { ButtonSize } from '../../../globals/button/button.enum';
import { UnsubscribeBaseModel } from '../../../../base/model/UnsubscribeBase.model';
import Constants from '../../../../Constants';
import { PropagateOpts } from '../../../../models/form/base-cp-form.model';
import { takeUntil } from 'rxjs/operators';
import { finalize } from 'rxjs';
import { AuthPageCommonComponent } from '../auth-page-common.component';
import { FormInputComponent } from '../../../components/input/form-input/form-input.component';
import { InlineButtonComponent } from '../../../globals/button/inline-button/inline-button.component';
import { ButtonComponent } from '../../../globals/button/button/button.component';
import { MessageDesignBSmallComponent } from '../../../components/message-design-b/message-design-b-small/message-design-b-small.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'cp-forgot-password-page',
    templateUrl: './forgot-password-page.component.html',
    styleUrls: ['./forgot-password-page.component.scss', '../auth-page-common.scss'],
    imports: [AuthPageCommonComponent, FormInputComponent, InlineButtonComponent, ButtonComponent, MessageDesignBSmallComponent, TranslateModule]
})
export class ForgotPasswordPageComponent extends UnsubscribeBaseModel implements OnInit {

  //region INJECTIONS
  private router: Router = inject(Router);
  private authService: AuthserviceService = inject(AuthserviceService);
  private app: CompoApp = inject(CompoApp);
  //endregion

  //region FORM
  readonly EMAIL_OR_LOGIN_NAME = 'emailOrLoginName';
  readonly formGroup: UntypedFormGroup = new UntypedFormGroup({
    [this.EMAIL_OR_LOGIN_NAME]: new FormControl(null)
  });
  //endregion

  //region FIELDS
  protected readonly MessageSeverity = MessageSeverity;

  showRequestSentMessage: boolean;
  validatorsSet: boolean;
  inProgress: boolean = false;
  //endregion

  //region LIFECYCLE

  ngOnInit() {
    this.app.data.clear();

    this.formGroup.valueChanges
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((value: any) => {
        if (value) {
          const emailOrLoginValue: string = value[this.EMAIL_OR_LOGIN_NAME];
          if (!this.validatorsSet && emailOrLoginValue && emailOrLoginValue.length > 0) {
            this.setValidators();
            this.showRequestSentMessage = false;
          }
        }
      });
  }
  //endregion

  //region METHODS
  onSendResetRequest(): void {
    if (this.formGroup.invalid || this.showRequestSentMessage) {
      return;
    }

    const loginOrEmail: string = this.formGroup.get(this.EMAIL_OR_LOGIN_NAME).value;

    if (!loginOrEmail || !loginOrEmail.length) {
      this.setValidators();
      return;
    }

    this.inProgress = true;
    this.formGroup.disable(PropagateOpts.EMIT_EVENT_FALSE);

    this.authService.requestPwdResetLink(loginOrEmail)
      .pipe(
        takeUntil(this.unSubscribe$),
        finalize(() => {
          this.inProgress = false;
          this.formGroup.enable(PropagateOpts.EMIT_EVENT_FALSE);
        })
      )
      .subscribe(() => {
        this.showRequestSentMessage = true;
        this.formGroup.reset(PropagateOpts.EMIT_EVENT_FALSE);
        const emailControl: FormControl = this.formGroup.get(this.EMAIL_OR_LOGIN_NAME) as FormControl;
        emailControl.clearValidators();
        emailControl.updateValueAndValidity(PropagateOpts.EMIT_EVENT_FALSE);
        this.validatorsSet = false;
      });
  }

  onBackToLogin(): void {
    this.router.navigate(['']);
  }

  private setValidators(): void {
    const emailControl: FormControl = this.formGroup.get(this.EMAIL_OR_LOGIN_NAME) as FormControl;
    if (emailControl) {
      emailControl.setValidators(Validators.required);
      emailControl.updateValueAndValidity(PropagateOpts.EMIT_EVENT_FALSE);
      this.validatorsSet = true;
    }
  }
  //endregion
}
